var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEstimateReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 194,
    viewBox: "0 0 295 194",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M278.308 36.5068L72.1513 91.8723L23.2378 165.905L-27 113.025",
    stroke: "url(#paint0_linear_952_2053)",
    strokeWidth: 11.7605
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.666 59.9055L265.897 16.1872L311.108 26.7062L278.666 59.9055Z",
    fill: "#024FCB",
    stroke: "url(#paint1_linear_952_2053)",
    strokeWidth: 0.588024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.378 95.5142L173.421 49.4287",
    stroke: "black",
    strokeWidth: 1.76407
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_952_2053)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 94.9297,
    y: 6.70215,
    width: 136.465,
    height: 179.52,
    rx: 1.76407,
    fill: "url(#paint2_linear_952_2053)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 80.1277,
    x2: 213.878,
    y2: 80.1277,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 110.87,
    x2: 213.878,
    y2: 110.87,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 141.609,
    x2: 213.878,
    y2: 141.609,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 88.7723,
    x2: 201.404,
    y2: 88.7723,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 119.514,
    x2: 201.404,
    y2: 119.514,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.567,
    y1: 150.26,
    x2: 201.404,
    y2: 150.26,
    stroke: "#2876F1",
    strokeWidth: 1.76407,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.531,
    cy: 46.0604,
    r: 14.9822,
    fill: "#C1D9FF",
    stroke: "#C1D9FF",
    strokeWidth: 0.588024
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.515 46.5771C124.603 46.5774 127.918 49.8926 127.919 53.9805C127.919 54.0334 127.916 54.088 127.915 54.1406H127.92V59.4326C125.73 60.6452 123.212 61.3369 120.531 61.3369C117.839 61.3369 115.309 60.6389 113.112 59.416V54.1406H113.115C113.114 54.088 113.111 54.0334 113.111 53.9805C113.112 49.8926 116.427 46.5775 120.515 46.5771ZM120.508 37.9834C122.747 37.9834 124.562 39.7993 124.562 42.0381C124.562 44.2773 122.747 46.0928 120.508 46.0928C118.269 46.0925 116.453 44.2771 116.453 42.0381C116.454 39.7995 118.269 37.9836 120.508 37.9834Z",
    fill: "url(#paint3_linear_952_2053)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.57,
    y: 73.6349,
    width: 19.2317,
    height: 19.2317,
    rx: 1.76407,
    stroke: "#2876F1",
    strokeWidth: 1.17605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.721,
    y: 104.663,
    width: 19.2317,
    height: 19.2317,
    rx: 1.76407,
    stroke: "#2876F1",
    strokeWidth: 1.17605
  }), /*#__PURE__*/React.createElement("rect", {
    x: 110.57,
    y: 135.692,
    width: 19.2317,
    height: 19.2317,
    rx: 1.76407,
    stroke: "#2876F1",
    strokeWidth: 1.17605
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.029 84.0442L119.092 87.7731L125.67 77.6406",
    stroke: "#2876F1",
    strokeWidth: 1.17605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.188 115.071L119.252 118.8L125.829 108.667",
    stroke: "#2876F1",
    strokeWidth: 1.17605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.029 146.643L119.092 150.372L125.67 140.239",
    stroke: "#2876F1",
    strokeWidth: 1.17605,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-19-inside-1_952_2053",
    fill: "white"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 123.804,
    width: 78.7254,
    height: 17.1182,
    rx: 1.44311
  })), /*#__PURE__*/React.createElement("rect", {
    x: 123.804,
    width: 78.7254,
    height: 17.1182,
    rx: 1.44311,
    stroke: "url(#paint4_linear_952_2053)",
    strokeWidth: 4,
    mask: "url(#path-19-inside-1_952_2053)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 134.647,
    y: 12.0312,
    width: 57.0394,
    height: 8.34206,
    rx: 1.44311,
    fill: "#266CDA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_952_2053",
    x: 91.0487,
    y: 4.58526,
    width: 145.403,
    height: 188.458,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.588024,
    dy: 2.3521
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.23449
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.623088 0 0 0 0 0.714621 0 0 0 0 0.819231 0 0 0 0.5 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_952_2053"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_952_2053",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_952_2053",
    x1: 269.732,
    y1: 36.5068,
    x2: 186.966,
    y2: 242.158,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024FCB",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_952_2053",
    x1: 318.794,
    y1: 50.8874,
    x2: 254.376,
    y2: 16.6982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#024FCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#024FCB",
    stopOpacity: 0.42
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_952_2053",
    x1: 96.824,
    y1: 6.70215,
    x2: 229.5,
    y2: 186.222,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#74A3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.250262,
    stopColor: "#B4CDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E3E9F3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_952_2053",
    x1: 120.516,
    y1: 37.9834,
    x2: 120.516,
    y2: 63.1853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#017BFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0250CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_952_2053",
    x1: 202.529,
    y1: 13.6717,
    x2: 194.469,
    y2: -24.9219,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3A7EE9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEstimateReport);
export default __webpack_public_path__ + "static/media/EstimateReport.40b38807bc17f7359e6a8802426a1db7.svg";
export { ForwardRef as ReactComponent };